import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import NewsletterService from '../../services/NewsletterService';
import { PERIOD_TYPES } from './constants';
import { CategoryTags } from './CategoryTags';
import { ChannelsTable } from './ChannelsTable';
import { CoverSettings } from './CoverSettings';

const EMPTY = {
  name: '',
  period_type: 'days',
  period_qty: 15,
  top_n: 10,
  title_pdf: 'Novedades Inkit',
  main_categories: [],
  channels_config: [],
  cover_image_url: '',
  cover_image: '',
  active: true,
};

// Defaults de la tapa. Deben coincidir con cover_templates.DEFAULTS del backend.
const EMPTY_COVER = {
  cover_bg_color: '#F0F0F0',
  cover_title_color: '#4A4A4A',
  cover_period_color: '#4A4A4A',
  cover_rule_color: '#7EBB00',
  cover_description: '',
  cover_contact_email: '',
  cover_socials: [],
};

export function NewsletterNovedadesForm({ initial, isNew, onSubmit, saving, onCancel }) {
  const [form, setForm] = useState(initial || EMPTY);
  const [channels, setChannels] = useState([]);
  const [categories, setCategories] = useState([]);
  const [palette, setPalette] = useState([]);
  const [socials, setSocials] = useState([]);

  // Campos de la tapa. No hay plantillas: solo colores de la paleta de marca.
  const [cover, setCover] = useState(EMPTY_COVER);

  useEffect(() => {
    setForm(initial || EMPTY);
  }, [initial]);

  useEffect(() => {
    (async () => {
      try {
        const [chRes, catRes, optRes] = await Promise.all([
          NewsletterService.getChannels(),
          NewsletterService.getMainCategories(),
          NewsletterService.getCoverOptions(),
        ]);
        setChannels(chRes.data || []);
        setCategories(catRes.data || []);
        setPalette(optRes.data?.palette || []);
        setSocials(optRes.data?.socials || []);
      } catch (e) {}
    })();
  }, []);

  // La tapa toma los valores por defecto y luego los sobrepola con lo guardado.
  useEffect(() => {
    const saved = initial || {};
    const merged = { ...EMPTY_COVER };
    [
      'cover_bg_color', 'cover_title_color', 'cover_period_color',
      'cover_rule_color', 'cover_description', 'cover_contact_email',
      'cover_socials',
    ].forEach(k => {
      if (saved[k] !== undefined && saved[k] !== null && saved[k] !== '') merged[k] = saved[k];
    });
    setCover(merged);
  }, [initial]);

  const setField = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    // La descripcion solo se guarda marcada para mostrarse; el texto se
    // conserva siempre para no perderlo al desactivar.
    onSubmit({
      ...form,
      ...cover,
      cover_description: cover.cover_description || '',
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row g-3">
        <div className="col-12">
          <label className="form-label text-white-50">Título PDF</label>
          <input className="form-control bg-dark text-white border-secondary py-2" value={form.title_pdf} onChange={e => setField('title_pdf', e.target.value)} />
        </div>
        <div className="col-md-6">
          <label className="form-label text-white-50">Periodo *</label>
          <select className="form-select bg-dark text-white border-secondary py-2" value={form.period_type} onChange={e => setField('period_type', e.target.value)}>
            {PERIOD_TYPES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
          </select>
        </div>
        <div className="col-md-6">
          <label className="form-label text-white-50">Cantidad *</label>
          <input type="number" min="1" className="form-control bg-dark text-white border-secondary py-2" value={form.period_qty} onChange={e => setField('period_qty', parseInt(e.target.value) || 1)} required />
        </div>
        <div className="col-md-6">
          <label className="form-label text-white-50">Top de títulos *</label>
          <input type="number" min="1" className="form-control bg-dark text-white border-secondary py-2" value={form.top_n} onChange={e => setField('top_n', parseInt(e.target.value) || 1)} required />
        </div>
        <div className="col-md-6">
          <label className="form-label text-white-50">Correo de contacto</label>
          <input type="email" className="form-control bg-dark text-white border-secondary py-2" value={cover.cover_contact_email || ''} onChange={e => setCover({ ...cover, cover_contact_email: e.target.value })} placeholder="contacto@ink-it.ink" />
        </div>
        <div className="col-12">
          <label className="form-label text-white-50">Categorías principales</label>
          <CategoryTags
            value={form.main_categories}
            options={categories}
            onChange={v => setField('main_categories', v)}
          />
        </div>
        <div className="col-12">
          <label className="form-label text-white-50">Canales</label>
          <ChannelsTable
            channels={form.channels_config}
            available={channels}
            onChange={v => setField('channels_config', v)}
          />
        </div>
        <div className="col-12">
          <CoverSettings
            palette={palette}
            socials={socials}
            value={cover}
            onChange={setCover}
          />
        </div>
      </div>
      <div className="d-flex justify-content-end gap-2 mt-3">
        <button type="button" className="btn btn-ink-outline" onClick={onCancel} disabled={saving}>Cancelar</button>
        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? <><FontAwesomeIcon icon={faSpinner} spin className="me-1" /> Guardando...</> : (isNew ? 'Crear' : 'Guardar')}
        </button>
      </div>
    </form>
  );
}